import * as React from 'react'

import { Download } from 'lucide-react'
import { observer } from 'mobx-react'

import LogisticsMapViewSetUpStore from '~/client/src/shared/components/LogisticsMapView/LogisticsMapViewSetUp.store'
import MapControlButton from '~/client/src/shared/components/MapControls/primitives/MapControlButton'
import MapExportStore from '~/client/src/shared/components/MapExport/MapExport.store'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  exportStore: MapExportStore
  setUpStore: LogisticsMapViewSetUpStore
}

const ShareMapButton: React.FC<IProps> = ({ exportStore, setUpStore }) => {
  if (!exportStore.canOpen || setUpStore.isMapFirstCreationActive) {
    return null
  }
  const label = Localization.translator.mapExport.shareMap
  return (
    <MapControlButton
      aria-label={label}
      title={label}
      onClick={exportStore.open}
    >
      <Download aria-hidden="true" />
    </MapControlButton>
  )
}

export default observer(ShareMapButton)
